"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.easeInOutQuad = void 0;
/**
 *
 * @param time
 * @param startValue
 * @param changeInValue
 * @param duration
 */
function easeInOutQuad(time, startValue, changeInValue, duration) {
    let t = time / (duration / 2);
    if (t < 1) {
        return (changeInValue / 2) * t * t + startValue;
    }
    t--;
    return (-changeInValue / 2) * (t * (t - 2) - 1) + startValue;
}
exports.easeInOutQuad = easeInOutQuad;
